import React, {useCallback} from "react"
import {useNavigate, useParams} from "react-router-dom"
import {useConfig} from "../../hooks/useConfig"
import {useParticipant} from "../../hooks/useParticipant"
import {useBoothSession} from "../../hooks/useBoothSession"
import WrapUpView from "../views/WrapUpView"

function WrapUpPage() {
  const params = useParams<"code">()
  const code = params.code!
  const navigate = useNavigate()

  const {config, loading} = useConfig(code)
  const {participant} = useParticipant(config?.presetCode ?? code)
  const {rawImage, compositeImage, clearImages} = useBoothSession(config?.presetCode ?? code)

  const handleFinish = useCallback((uploadCode: string) => {
    if (!config) return
    navigate(`/${config.presetCode}/pic/${uploadCode}/new`)
  }, [config, navigate])

  const resetBooth = useCallback(() => {
    if (!config) return
    clearImages()
    navigate(`/${config.presetCode}/camera`)
  }, [config, navigate, clearImages])

  if (loading || !config) {
    return null
  }

  // Redirect to camera if no images
  if (!rawImage || !compositeImage) {
    navigate(`/${config.presetCode}/camera`, {replace: true})
    return null
  }

  return (
    <WrapUpView
      config={config}
      rawFrame={rawImage}
      compositeImage={compositeImage}
      participant={participant}
      finish={handleFinish}
      reset={resetBooth}
    />
  )
}

export default WrapUpPage